/** Frontend-API für den Goal-Tree-Editor (compass-new Layer 1, CRUD). */

export interface GoalNode {
  id: number;
  parentId: number | null;
  companyId: number;
  type: 'vision' | 'pillar' | 'objective' | 'kpi';
  text: string;
  weight: number;
  hardConstraints: Record<string, unknown>;
  softSignals: Record<string, unknown>;
  active: boolean;
  relevanceDescription: string;
}

const URL = '/api/goal-tree';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function listGoalTree(companyId: number): Promise<GoalNode[]> {
  const r = await fetchJson<{ nodes: GoalNode[] }>(`${URL}/${companyId}`);
  return r.nodes;
}

export async function createGoalNode(node: Partial<GoalNode>): Promise<GoalNode> {
  return fetchJson<GoalNode>(URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(node) });
}

export async function updateGoalNode(id: number, fields: Partial<GoalNode>): Promise<GoalNode> {
  return fetchJson<GoalNode>(`${URL}/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(fields) });
}

export async function deleteGoalNode(id: number): Promise<void> {
  await fetchJson(`${URL}/${id}`, { method: 'DELETE' });
}
